import { useState, useEffect } from "react";

// import SortDoubts from "../components/home/SortDoubts";
import DoubtOnFeed from "../components/home/DoubtOnFeed";
import Loading from "../components/utils/Loading";
import NotFound from "../components/utils/NotFound";

import "./css/home.css";

import { readManyDoubts } from "../functions/server-requests/doubt";
import dateSlicer from "../functions/dateSlicer";

const Home = () => {
    const [doubts, setDoubts] = useState(null);

    document.title = "Feed - DSolve";

    useEffect(() => {
        const getDoubts = async () => {
            const getDoubtsRes = await readManyDoubts();

            if (getDoubtsRes.status === 200) {
                const doubtsArray = getDoubtsRes.data.manyDoubtsDetails;

                doubtsArray.sort((a, b) => {
                    return Date.parse(b.askedOn) - Date.parse(a.askedOn);
                })

                setDoubts(doubtsArray);
            }
            else {
                setDoubts(undefined);
            }
        }

        getDoubts();
    }, []);

    // const sortByRecentlyAsked = () => {
    //     const sortedDoubts = doubts.sort((a, b) => {
    //         return Date.parse(b.askedOn) - Date.parse(a.askedOn);
    //     })

    //     setDoubts(sortedDoubts);
    // }

    // const sortByRecentlyUpdated = () => {
    //     const sortedDoubts = doubts.sort((a, b) => {
    //         return Date.parse(b.updatedOn) - Date.parse(a.updatedOn);
    //     })

    //     setDoubts(sortedDoubts);
    // }

    // const sortByMostLiked = () => {
    //     const sortedDoubts = doubts.sort((a, b) => {
    //         return b.likes - a.likes;
    //     })

    //     setDoubts(sortedDoubts);
    // }

    if (doubts === null) {
        return <Loading />;
    }

    else if (doubts === undefined) {
        return <NotFound />;
    }

    else {
        return (
            <div className="home">
                {/* <SortDoubts
                    sortByMostLiked={sortByMostLiked}
                    sortByRecentlyAsked={sortByRecentlyAsked}
                    sortByRecentlyUpdated={sortByRecentlyUpdated}
                /> */}

                {doubts.map((item, key) => {
                    return (
                        <DoubtOnFeed
                            key={key}
                            doubtId={item._id}
                            askedById={item.askedById}
                            askedBy={item.askedBy}
                            askedByRole={item.askedByRole}
                            askedOn={dateSlicer(item.askedOn)}
                            updatedOn={dateSlicer(item.updatedOn)}
                            title={item.title}
                            desc={item.desc}
                            isSolved={item.isSolved}
                            likes={item.likes}
                            likedBy={item.likedBy}
                        />
                    );
                })}
            </div>
        );
    }
}

export default Home;